import React, { useMemo } from 'react';
import { HealthPlanStatuses } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks/useCurrentOrganization';

import HealthPlanActivation from './HealthPlanActivation';
import HealthPlanTopbarActions from './HealthPlanTopbarActions';
import HealthPlanTopbarEditModeButton from './HealthPlanTopbarEditModeButton';
import TopbarWrapper from './TopbarWrapper';

interface Props {
  planStatus?: HealthPlanStatuses;
  hasUnselectedServiceTypes?: boolean;
  viewMode?: boolean;
  isTemplateMode?: boolean;
  isHealthPlanActive?: boolean;
  saveButtonRef?: React.RefObject<HTMLButtonElement | null | undefined>;
  activateButtonRef?: React.RefObject<HTMLButtonElement | null | undefined>;
  reviewButtonRef?: React.RefObject<HTMLButtonElement | null | undefined>;
}
const HealthPlanTopbar: React.FC<Props> = ({
  planStatus,
  hasUnselectedServiceTypes,
  viewMode,
  isTemplateMode,
  isHealthPlanActive,
  saveButtonRef,
  reviewButtonRef,
  activateButtonRef,
}) => {
  const { observingOrganization: { type } } = useCurrentOrganization();
  const isSubsidiary = useMemo(
    () => type === OrganizationTypes.subsidiary,
    [type],
  );
  const node = useMemo(() => {
    if (isSubsidiary) return null;
    if (planStatus !== HealthPlanStatuses.ACTIVE && planStatus !== HealthPlanStatuses.PENDING_ACTIVE) {
      if (viewMode) {
        return <HealthPlanTopbarEditModeButton isDraftMode={planStatus === HealthPlanStatuses.DRAFT} />;
      }

      return (
        <HealthPlanTopbarActions
          saveButtonRef={saveButtonRef}
          activateButtonRef={activateButtonRef}
          reviewButtonRef={reviewButtonRef}
          viewMode={viewMode}
          isTemplateMode={isTemplateMode}
          hasUnselectedServiceTypes={hasUnselectedServiceTypes}
        />
      );
    }
    return <HealthPlanActivation updateButtonRef={saveButtonRef} isTemplateMode={isTemplateMode} isHealthPlanActive={isHealthPlanActive} />;
  }, [
    activateButtonRef,
    hasUnselectedServiceTypes,
    isHealthPlanActive,
    isTemplateMode,
    planStatus,
    reviewButtonRef,
    saveButtonRef,
    viewMode,
    isSubsidiary,
  ]);
  return <TopbarWrapper>{node}</TopbarWrapper>;
};
export default HealthPlanTopbar;
